import Vue from "vue";
import VueRouter from "vue-router";
import breadcrumbNavDataStore from "@/store/breadcrumbNavDataStore";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    meta: { breadcrumbName: "首页", breadcrumbAction: "clear",keepAlive: false, deepth: 1},
    component: () => import("@/views/home/index"),
  },
  {
    path: "/rtfPreview",
    name: "rtfPreview",
    meta: { breadcrumbName: "资讯详情",keepAlive: false, deepth: 1 },
    component: () => import("@/views/rtf/rtfPreview"),
  },
  {
    path: "/rtfPreviewDetail",
    name: "rtfPreviewDetail",
    meta: { breadcrumbName: "资讯详情",keepAlive: false, deepth: 1 },
    component: () => import("@/views/rtf/rtfPreviewDetail"),
  },
  {
    path: "/needLand/indexCopy",
    name: "needLandIndex",
    meta: { breadcrumbAction: "clear",keepAlive: false, deepth: 1, },
    component: () => import("@/views/needLand/indexCopy"),
  },
  {
    path: "/park/list",
    name: "parkList",
    meta: { breadcrumbName: "园区（开发区）", breadcrumbAction: "clear",keepAlive: true, deepth: 1 },
    // component: () => import("@/views/park/list"),
    component: ()=> import("@/views/park/listCopy")
    
  },
  {
    path: "/industry/list",
    name: "industryList",
    meta: { breadcrumbName: "行业动态", breadcrumbAction: "clear", keepAlive: true, deepth: 1},
    component: () => import("@/views/industryDynamic/list"),
  },
  {
    path: "/parkDetail",
    name: "parkDetail",
    meta: { breadcrumbName: "园区（开发区）详情",keepAlive: false, deepth: 1 },
    component: () => import("@/views/park/parkDetailCopy"),
  },
  // {
  //   path: "/park/contrast",
  //   name: "contrast",
  //   meta: { breadcrumbName: "对比开发区（园区）" ,keepAlive: false, deepth: 1},
  //   component: () => import("@/views/park/components/contrast"),
  // },
  {
    path: "/land/list",
    name: "landList",
    meta: { breadcrumbName: "土地超市", breadcrumbAction: "clear",keepAlive: true, deepth: 1 },
    component: () => import("@/views/land/list"),
  },
  {
    path: "/land/detail",
    name: "landDetail",
    meta: { breadcrumbName: "地块详情",keepAlive: false, deepth: 1 },
    component: () => import("@/views/land/landDetailCopy"),
  },
  {
    path: "/land/contrast",
    name: "contrast",
    meta: { breadcrumbName: "对比地块" ,keepAlive: false, deepth: 1},
    component: () => import("@/views/land/components/contrast"),
  },
  {
    path: "/land/releaseNeed",
    name: "releaseNeed",
    meta: { keepAlive: false, deepth: 1},
    component: () => import("@/views/land/from"),
  },
  {
    path:"/mine",
    name:"mine",
    meta:{ breadcrumbAction: "clear", keepAlive:false, deepth: 1},
    component :() => import("@/views/mine/mine")
  },
  {
    path: "/promotion/list",
    name: "promotion",
    meta: { breadcrumbName: "推介专场", breadcrumbAction: "clear" ,keepAlive: false, deepth: 1},
    component: () => import("@/views/promotion/list"),
  },
  {
    path:"/project/list",
    name:"projectList",
    meta: { breadcrumbName: "项目招商", breadcrumbAction: "clear" ,keepAlive: true, deepth: 1},
    component:()=> import("@/views/project/list")
  },
  {
    path:"/project/detail",
    name:"projectDetail",
    meta: { breadcrumbName: "项目详情",keepAlive: false, deepth: 1 },
    component: () => import("@/views/project/projectDetails"),
  },

  {
    path: "/industryDetail",
    name: "industryDetail",
    meta: { breadcrumbName: "产业聚集区详情" ,keepAlive: false, deepth: 1},
    component: () => import("@/views/industry/industryDetail"),
  },
  {
    path: "/laws/list",
    name: "lawsList",
    meta: { breadcrumbName: "政策法规", breadcrumbAction: "clear" ,keepAlive: false, deepth: 1},
    component: () => import("@/views/laws/list"),
  },
  
  {
    path: "/centralYunnan",
    name: "centralYunnan",
    meta: { breadcrumbName: "推介专场", breadcrumbAction: "clear" ,keepAlive: false, deepth: 1},
    component: () => import("../views/formWork/centralYunnan"),
  },
  {
    path: "/formWorkOne",
    name: "formWorkOne",
    meta: { breadcrumbName: "推介专场", breadcrumbAction: "clear",keepAlive: false, deepth: 1 },
    component: () => import("../views/formWork/formWorkOne"),
  },
  {
    path: "*",
    name: "notfound",
    component: () => import("@/views/notfound/index"),
  },
  {
    path: "/black",
    meta: { title: "点击同一路由刷新当前路由" },
    component: () => import("../views/black.vue"),
  },
  {
    path:"/login",
    name:"login",
    meta:{breadcrumbName: "登录",keepAlive: false, deepth: 1},
    component:()=> import("../components/login/login")
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
//重复点击统一路由报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeResolve((to, form, next) => {
  // 把params存sessionStorage，防止刷新丢失
  if (Object.keys(to.params).length) {
    sessionStorage.setItem(to.name, JSON.stringify(to.params));
  }
  if (Object.keys(to.meta).length) {
    
    if (to.meta.breadcrumbAction === "clear") {
      breadcrumbNavDataStore.removeData(0);
    }
    if (to.meta.breadcrumbName) {
      let data = breadcrumbNavDataStore.getData();
      if(data.findIndex((item)=> item.path==to.path) == -1){
        breadcrumbNavDataStore.addData(to.meta.breadcrumbName, to.path,to.query);
      }
    }
  }
  next();
});

export default router;
